var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitSearchMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5005 9.99941V10.9993C13.5005 11.2055 13.3317 11.3743 13.1254 11.3743H7.87519C7.66893 11.3743 7.50017 11.2055 7.50017 10.9993V9.99941C7.50017 9.79318 7.66893 9.62445 7.87519 9.62445H13.1254C13.3317 9.62445 13.5005 9.79318 13.5005 9.99941ZM19.782 18.8954L18.8976 19.7797C18.6038 20.0734 18.1288 20.0734 17.8382 19.7797L14.7193 16.6644C14.5786 16.5238 14.5005 16.3332 14.5005 16.1332V15.6239C13.3973 16.4863 12.0098 16.9987 10.5003 16.9987C6.90952 16.9987 4 14.0896 4 10.4994C4 6.90909 6.90952 4 10.5003 4C14.0911 4 17.0006 6.90909 17.0006 10.4994C17.0006 12.0086 16.4881 13.396 15.6256 14.499H16.135C16.335 14.499 16.5256 14.5771 16.6662 14.7177L19.782 17.833C20.0727 18.1267 20.0727 18.6017 19.782 18.8954ZM14.7505 10.4994C14.7505 8.14959 12.8504 6.24978 10.5003 6.24978C8.1502 6.24978 6.25011 8.14959 6.25011 10.4994C6.25011 12.8491 8.1502 14.749 10.5003 14.749C12.8504 14.749 14.7505 12.8491 14.7505 10.4994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitSearchMinus);
export default __webpack_public_path__ + "static/media/aitSearchMinus.218294a3d1b4cba670ed408236f9b2a9.svg";
export { ForwardRef as ReactComponent };